import React, { useRef, useCallback } from 'react'
import { useVirtualizer } from '@tanstack/react-virtual'

const VirtualList = ({
  items,
  renderItem,
  estimateSize = 72,
  overscan = 5,
  getItemKey,
  className,
  style
}) => {
  const scrollRef = useRef(null)

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => estimateSize,
    overscan,
    getItemKey: getItemKey
      ? (index) => getItemKey(items[index], index)
      : undefined,
    measureElement: (el) => el?.getBoundingClientRect().height ?? estimateSize
  })

  const measureRef = useCallback(
    (node, virtualRow) => {
      if (node) virtualizer.measureElement(node)
    },
    [virtualizer]
  )

  const virtualItems = virtualizer.getVirtualItems()

  return (
    <div
      ref={scrollRef}
      className={className}
      style={{
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        height: '100%',
        ...style
      }}
    >
      <div
        style={{
          height: virtualizer.getTotalSize(),
          position: 'relative',
          width: '100%'
        }}
      >
        {virtualItems.map((virtualRow) => {
          const item = items[virtualRow.index]

          return (
            <div
              key={virtualRow.key}
              ref={(node) => measureRef(node, virtualRow)}
              data-index={virtualRow.index}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                transform: `translateY(${virtualRow.start}px)`
              }}
            >
              {renderItem({ item, index: virtualRow.index, virtualRow })}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default VirtualList
